import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ExamService } from 'src/app/core/exam.service';
import { Exam } from 'src/app/models/exam.model';

@Component({
  selector: 'app-exam-result',
  templateUrl: './exam-result.component.html',
  styleUrls: ['./exam-result.component.scss'],
  standalone: false
})
export class ExamResultComponent {

  @Input() exam!: Exam;
  @Output() examChange: EventEmitter<Exam> = new EventEmitter<Exam>();

  isGeneratingResult: boolean = false;

  constructor(
    private examService: ExamService
  ) {}

  ngOnInit(): void {
    if (!this.exam.isFinished) {
      this.isGeneratingResult = true;
      this.examService.generateExamResult(this.exam.id!).subscribe((result: any) => {
        const newExam: Exam = Exam.constructExam(result);
        this.examChange.emit(newExam);
        this.isGeneratingResult = false;
      });
    }
  }
}
